export function mapNetworthError(code: string): string {
  switch (code) {
    case "DUPLICATE_SNAPSHOT":
      return "networth.errors.duplicate_snapshot";
    case "FUTURE_DATE":
      return "networth.errors.future_date";
    case "VALIDATION_ERROR":
      return "networth.errors.validation";
    case "NOT_FOUND":
      return "networth.errors.not_found";
    case "AUTHENTICATION_ERROR":
      return "errors.unauthenticated";
    default:
      return "errors.unknown";
  }
}
